import React from 'react';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import styles from './index.module.scss';

const { from: fromName, to: toName } = fieldNames.scheduleSettingInterval;

const Period = ({ field }) => {
  return (
    <span>
      <span className={styles.time}>{field[fromName]}</span>
      <span className={styles.hyphen}>{' – '}</span>
      <span className={styles.time}>{field[toName]}</span>
    </span>
  );
};

export default Period;
